// Vendors
import { apiUtils } from '@openbank/cf-ui-architecture-core';
// Constants
import { POST_PAYMENT_SERVICE_CONFIGURATION } from './constants/payment-landing.services.constants';
// Types
import { PaymentLandingApiDataApiResponseType } from '../types/payment-landing-api-response.type';

const initiatePaymentService = async (): Promise<
  [PaymentLandingApiDataApiResponseType, Response]
> => apiUtils.post(POST_PAYMENT_SERVICE_CONFIGURATION);

export { initiatePaymentService };
